import React from 'react';
import { Field, CccisdInput, CccisdToggle } from 'cccisd-formik';
import { widgetBuilder } from 'cccisd-laravel-appdefs';

export const initialValues = {
    show: true,
    overallFidelity: {
        show: true,
        title: 'Overall Fidelity',
        description: '',
        targetScore: 4,
    },
    foundational: {
        show: true,
        title: 'Foundational Fidelity',
        description: '',
        targetScore: 4,
    },
    leadership: {
        show: true,
        title: 'Group Leadership Fidelity',
        description: '',
        targetScore: 4,
    },
};

const Component = props => {
    return (
        <div>
            <Field name="show" component={CccisdToggle} label="Show Summary Callouts?" />
            <h4>Callout 1</h4>
            <Field name="overallFidelity.show" component={CccisdToggle} label="Show Callout 1?" />
            <Field name="overallFidelity.title" component={CccisdInput} label="Title" />
            <Field name="overallFidelity.description" component={CccisdInput} label="Description" />
            <Field
                name="overallFidelity.targetScore"
                component={CccisdInput}
                label="Target Score"
                type="number"
            />
            <h4>Callout 2</h4>
            <Field name="foundational.show" component={CccisdToggle} label="Show Callout 2?" />
            <Field name="foundational.title" component={CccisdInput} label="Title" />
            <Field name="foundational.description" component={CccisdInput} label="Description" />
            <Field
                name="foundational.targetScore"
                component={CccisdInput}
                label="Target Score"
                type="number"
            />
            <h4>Callout 3</h4>
            <Field name="leadership.show" component={CccisdToggle} label="Show Callout 3?" />
            <Field name="leadership.title" component={CccisdInput} label="Title" />
            <Field name="leadership.description" component={CccisdInput} label="Description" />
            <Field
                name="leadership.targetScore"
                component={CccisdInput}
                label="Target Score"
                type="number"
            />
        </div>
    );
};

export default widgetBuilder({ initialValues })(Component);
